export const document360 = 'doc360';
